import React from "react";

export type CardVariant = "plain" | "glass" | "dark";

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: CardVariant;
};

export function Card({ variant = "plain", className, ...rest }: CardProps) {
  const cls = ["tb-card", `tb-card-${variant}`, className]
    .filter(Boolean)
    .join(" ");
  return <div className={cls} {...rest} />;
}
